import { render, staticRenderFns } from "./CopyClick.vue?vue&type=template&id=7bfb7cd0&"
import script from "./CopyClick.vue?vue&type=script&lang=js&"
export * from "./CopyClick.vue?vue&type=script&lang=js&"
import style0 from "./CopyClick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports